import { apiService } from '@/services/api';
import { EmailTemplate, EmailTemplatesApiResponse } from '@/types';
import { useQuery } from '@tanstack/react-query';

/**
 * Custom hook for fetching email templates for KYC email selection
 *
 * Fetches all email templates with per_page=500 to get all available templates
 * for the KYC email template selector
 */
export const useEmailTemplatesForKyc = () => {
  const {
    data: templatesResponse,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['email-templates-kyc'],
    queryFn: async (): Promise<EmailTemplatesApiResponse> => {
      const response = await apiService.get<EmailTemplatesApiResponse>(
        '/email-templates?per_page=500'
      );
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - templates don't change frequently
    retry: 1,
  });

  const templates = templatesResponse?.result || [];

  // Transform templates for select options
  const templateOptions = templates.map((template: EmailTemplate) => ({
    value: template.id.toString(),
    label: template.name,
    subject: template.subject,
    template: template,
  }));

  return {
    templates,
    templateOptions,
    isLoading,
    error,
    refetch,
  };
};
